export const MULTIPLEADD = "cart/multipleAdd";
export const REMOVEITEM = "cart/removeItem";
